<div class="destination-multiselect-container">
  @if (fieldLabel) {
<label class="field-label">{{fieldLabel}}</label>
}

  @if (selectedValues.length > 0) {
<div class="selected-values">
    @for (value of selectedValues; track trackByValue($index, value)) {
<div class="selected-chip">
      <span class="chip-text">{{ displayData[value]?.name || value }}</span>
      <button type="button" class="chip-remove" (click)="remove(value)" [title]="'Remove ' + value">
        <span class="ups-icon ups-icon-x"></span>
      </button>
    </div>
}
  </div>
}

  <div class="input-container">
    <input
      #optionInput
      [placeholder]="isMaxSelectionsReached() ? 'Maximum 5 Destinations' : inputPlaceholder"
      [formControl]="inputCtrl"
      [disabled]="isMaxSelectionsReached()"
      class="form-control destination-input"
      (keydown)="onKeyDown($event)"
      (focus)="onInputFocus()"
      type="text" />
  </div>

  @if (showDropdown && (autoCompleteOptions | async)?.length > 0) {
<div class="dropdown-container">
    @for (option of autoCompleteOptions | async; track trackByValue(i, option); let i = $index) {
<div class="dropdown-option"
        
         (click)="selected(option)"
         [class.disabled]="selectedValues.includes(option.value) || isMaxSelectionsReached()"
         [class.highlighted]="i === highlightedIndex">
      {{ option.name }}
    </div>
}
  </div>
}

  @if (isInvalidValue) {
<div class="error-message">
    {{localize(langSection.HomePage, langText.DestinationDoesNotExist)}}
  </div>
}
</div>
